import { Controller } from "@hotwired/stimulus"

const OPEN_CLASS = "is-open"

export default class AdminSidebarUserMenuController extends Controller {
  static targets = ["wrapper", "menu"]
  static values = { openOnConnect: { type: Boolean, default: false } }

  connect() {
    this.menuTarget.addEventListener("transitionend", this.clearMaxHeightBound)
    if (this.openOnConnectValue) {
      this.open()
    }
  }

  disconnect() {
    this.menuTarget.removeEventListener("transitionend", this.clearMaxHeightBound)
  }

  toggle() {
    const opening = !this.wrapperTarget.classList.contains(OPEN_CLASS)
    if (opening) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    const menu = this.menuTarget
    this.wrapperTarget.classList.add(OPEN_CLASS)
    this.menuTarget.classList.add(OPEN_CLASS)
    this.triggerElement.setAttribute("aria-expanded", "true")
    menu.style.maxHeight = "0"
    requestAnimationFrame(() => {
      menu.style.maxHeight = `${menu.scrollHeight}px`
    })
  }

  close() {
    const menu = this.menuTarget
    menu.style.maxHeight = `${menu.scrollHeight}px`
    requestAnimationFrame(() => {
      this.wrapperTarget.classList.remove(OPEN_CLASS)
      this.menuTarget.classList.remove(OPEN_CLASS)
      this.triggerElement.setAttribute("aria-expanded", "false")
      menu.style.maxHeight = "0"
    })
  }

  clearMaxHeightBound = () => {
    const menu = this.menuTarget
    if (!menu.classList.contains(OPEN_CLASS)) {
      menu.style.maxHeight = ""
    }
  }

  get triggerElement() {
    return this.wrapperTarget.querySelector("[data-action*='toggle']")
  }
}
